export const CUSTOMER_TAGS = "CUSTOMER_TAGS";
export const CUSTOMER_TAGS_SUCCESS = "CUSTOMER_TAGS_SUCCESS";
export const CUSTOMER_TAGS_FAIL = "CUSTOMER_TAGS_FAIL";
